import React, { ReactNode } from "react";
import { usePageStyles } from "../styles/usePageStyles";

interface HeroCardProps {
  title: string;
  subtitle?: string | ReactNode;
  avatar?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Large header card component with decorative glow effect
 */
export const HeroCard: React.FC<HeroCardProps> = ({
  title,
  subtitle,
  avatar,
  meta,
  actions,
  className,
  style
}) => {
  const styles = usePageStyles();

  return (
    <div 
      style={{ ...styles.heroCard, ...style }} 
      className={className}
    >
      {/* Decorative glow */}
      <div style={styles.heroGlow} />
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
        {avatar && <div>{avatar}</div>}
        <div style={{ flex: 1 }}>
          <h1 style={{ 
            margin: 0, 
            fontSize: '28px', 
            fontWeight: 600,
            letterSpacing: '-0.5px',
            marginBottom: '8px',
            color: styles.container.color
          }}>
            {title}
          </h1>
          {subtitle && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
              {subtitle}
            </div>
          )}
        </div>
      </div>
      
      {meta && (
        <div style={{ display: 'flex', gap: '40px', position: 'relative', zIndex: 1 }}>
          {meta}
        </div>
      )}
      
      {actions && (
        <div style={{ position: 'relative', zIndex: 1 }}>
          {actions}
        </div>
      )}
    </div>
  );
};
